import { useState } from 'react';
import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import Section from 'components/common/Section/Section';
import CustomText from 'components/common/CustomText/CustomText';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomDialog from 'components/dialogs/CustomDialog';
import { useSendReviewReminders } from 'hooks/useOrders';
import { snackbarService } from 'services/snackbarService';
import useGlobalStyles from 'styles/globalStyles';
import { colors } from 'styles/colors';

// Things done once, by hand, that otherwise wait for their schedule.
export default function ActionsPage() {
  const globalStyles = useGlobalStyles();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const { mutate: sendReviewReminders, isLoading } = useSendReviewReminders(
    (response) => {
      setConfirmOpen(false);
      snackbarService.showSnackbar(`Review reminder sent to ${response?.customers ?? 0} customers`, 'success');
    },
    (error: any) => {
      setConfirmOpen(false);
      snackbarService.showSnackbar(error?.response?.data?.message ?? error?.message, 'error');
    },
  );

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Actions'}
            buttons={[]}
          />
        </Box>

        <Box mt={3}>
          <Section
            title={'Review reminders'}
            content={
              <Box>
                <CustomText
                  text={'Sends the review reminder now to every customer with products still unrated, telling the points waiting for them. It is also sent every day at 18:00.'}
                  fontSize={14}
                  color={colors.gray}
                />
                <Box mt={2}>
                  <CustomButton
                    text={'Send review reminders'}
                    onClick={() => setConfirmOpen(true)}
                  />
                </Box>
              </Box>
            }
          />
        </Box>
      </Container>

      <CustomDialog
        open={confirmOpen}
        title='Send review reminders'
        message={'Every customer with unrated products gets a notification now. Send it?'}
        buttons={[
          <CustomButton
            key='cancel'
            text="Cancel"
            variant='outlined'
            color='primary'
            onClick={() => setConfirmOpen(false)}
            disabled={isLoading}
          />,
          <CustomButton
            key='send'
            text="Send"
            color='primary'
            onClick={() => sendReviewReminders()}
            isLoading={isLoading}
          />
        ]}
      />
    </Box>
  )
}
